<div class="summary-grid" *ngIf="flightSummary">
  <div class="summary-row" *ngIf="isSimple">
    <div class="summary-col">
      <div class="summary-label">Flight Type:</div>
      <div class="summary-value">{{ flightType || 'Unknown' }}</div>
    </div>
  </div>
  <div class="summary-row" *ngIf="!isSimple">
    <div class="summary-col">
      <div class="summary-label">Flight #:</div>
      <div class="summary-value">
        {{ flightLog?.flightSummaryId || flightLog?.flightTagNumber || 'Unknown' }}
      </div>
    </div>
    <div class="summary-col">
      <div class="summary-label">Date of Service:</div>
      <div class="summary-value">{{ dateOfService || 'Unknown' }}</div>
    </div>
    <div class="summary-col">
      <div class="summary-label">Flight Type:</div>
      <div class="summary-value">{{ flightType || 'Unknown' }}</div>
    </div>
    <div class="summary-col">
      <div class="summary-label">Flight Status:</div>
      <div class="summary-value">{{ flightStatus || 'Unknown' }}</div>
    </div>
    <div class="summary-col">
      <div class="summary-label">Flight Tag #:</div>
      <div class="summary-value">
        {{ flightLog?.flightTagNumber || 'Unknown' }}
      </div>
    </div>
  </div>
  <div class="summary-row" *ngIf="!isSimple">
    <div class="summary-col">
      <div class="summary-label">Base:</div>
      <div class="summary-value">{{ (base$ | async)?.name || 'Unknown' }}</div>
    </div>
    <div class="summary-col">
      <div class="summary-label">Tail #:</div>
      <div class="summary-value">
        {{ (aircraft$ | async)?.tailNumber || 'Unknown' }}
        <ng-container *ngIf="aircraft$ | async; let aircraft">
          <ng-container *ngIf="isAviationSupervisor && features.totalsMaintenanceSummary">
            (
            <a
              [routerLink]="'/maintenance/parameters/' + aircraft.id!"
              title="Mainage maintenance parameters."
              >Manage </a
            >)
          </ng-container>
        </ng-container>
      </div>
    </div>
    <div class="summary-col">
      <div class="summary-label">Aircraft Type:</div>
      <div class="summary-value">
        {{ (aircraft$ | async)?.aircraftType || 'Unknown' }}
      </div>
    </div>
    <div class="summary-col">
      <div class="summary-label">Aircraft Model:</div>
      <div class="summary-value">
        {{ (aircraft$ | async)?.model || 'Unknown' }}
      </div>
    </div>
    <div class="summary-col">
      <div class="summary-label">Updated By:</div>
      <div class="summary-value">
        {{ (updatedByEmployee$ | async) || 'Unknown' }}
      </div>
    </div>
  </div>
  <div class="summary-row" *ngIf="flightSummary && flightSummary.abortReason && !isSimple">
    <div class="summary-col">
      <div class="summary-label">Abort Reason:</div>
      <div class="summary-value">{{ flightSummary.abortReason }}</div>
    </div>
  </div>
</div>
<!--
  <div class="summary-row row-with-header" *ngIf="crewMembers.length > 0">
-->
<!-- <h3>Crew</h3> -->
<!-- <div *ngFor="let cm of crewMembers" class="summary-row"> -->
<!-- <div class="summary-col"> -->
<!-- <div class="summary-label">{{cm.role}}:</div> -->
<!-- <div class="summary-value"> -->
<!-- {{cm.name}} -->
<!-- <span *ngIf="cm.employeeId">({{cm.employeeId}})</span> -->
<!-- </div> -->
<!-- </div> -->
<!-- </div> -->
<!-- </div> -->
<!-- </div> -->
